import styled from 'styled-components'

const Title = styled.h1<{ expanded?: boolean }>`
  padding-top: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  align-items: center;
  color: rgb(26, 26, 26);
  margin: 0;
`

export default Title